var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3455 12.9625L17.3446 3.87054C16.9773 3.53417 16.4972 3.34762 15.9992 3.34766C15.5011 3.34769 15.0211 3.53431 14.6538 3.87072L4.65466 12.9625C4.44865 13.1501 4.28403 13.3786 4.17131 13.6334C4.05859 13.8882 4.00024 14.1637 4 14.4423V25.9999C4 26.2625 4.05174 26.5226 4.15226 26.7653C4.25279 27.008 4.40013 27.2285 4.58587 27.4142C4.77162 27.5999 4.99212 27.7472 5.23481 27.8477C5.47749 27.9482 5.73758 27.9999 6.00025 27.9999L11.9994 27.999C12.2646 27.9989 12.5189 27.8936 12.7064 27.706C12.8939 27.5185 12.9993 27.2641 12.9993 26.999V18.999H18.9993V26.999C18.9993 27.2641 19.1046 27.5185 19.2921 27.706C19.4796 27.8936 19.7339 27.9989 19.9991 27.999L25.9998 27.9999H26C26.2626 27.9999 26.5227 27.9481 26.7654 27.8476C27.008 27.7471 27.2285 27.5998 27.4142 27.4141C27.5999 27.2284 27.7473 27.0079 27.8478 26.7652C27.9483 26.5226 28 26.2625 28 25.9999V14.4424C27.9997 14.1638 27.9414 13.8883 27.8287 13.6335C27.716 13.3787 27.5514 13.1502 27.3455 12.9625Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.60a33301.svg";
export { ForwardRef as ReactComponent };